import { Component, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController, LoadingController, AlertController } from 'ionic-angular';
import {
  Validators,
  FormBuilder,
  FormGroup,
  FormControl
} from "@angular/forms";
import { DatabaseProvider } from '../../providers/database/database';
import { AuthProvider } from '../../providers/auth/auth';
import { SignaturePad } from 'angular2-signaturepad/signature-pad';

@IonicPage()
@Component({
  selector: 'page-clinic-doctors-add',
  templateUrl: 'clinic-doctors-add.html',
})

export class ClinicDoctorsAddPage {

  isExisting: boolean = false;
  operation_type: any = 'Add Doctor';

  clinic: any = {};
  clinic_id: string;
  clinic_name: string;

  doctor: any = {};
  doctor_id: string;
  first_name: FormControl;
  last_name: FormControl;
  license_number: FormControl;
  signature: string;
  isClinicAdmin: boolean = true;
  suppliesList: any = [];
  category_previous: string;

  addupdatedisabled: boolean = false;

  @ViewChild('sigpad1') signaturePad: SignaturePad; 
  isDrawing = false;

  public signaturePadOptions: Object = {
    minWidth: 2,
    canvasWidth: 500,
    canvasHeight: 150,
    backgroundColor: "#ffffff",
    penColor: "#6f6f6f"
  };

  constructor(    
    public navCtrl: NavController, 
    public navParams: NavParams, 
    private viewCtrl: ViewController, 
    private alertCtrl: AlertController,
    public formBuilder: FormBuilder,
    private database: DatabaseProvider,
    private auth: AuthProvider,
    private loadingCtrl: LoadingController) {

    this.auth.getCurrentUser().then(user => {

      this.clinic_name = user.clinic_name;
      this.clinic_id = user.clinic_id;
      this.isClinicAdmin = user.roles.clinic_admin;
      let doc: any = {};
      if (this.navParams.get('doctordata')) {
        doc = this.navParams.get('doctordata');
      } else {
        doc.id = 0;
      }
      this.database
      .getSupplyByClinic(this.clinic_id)
      .snapshotChanges()
      .map(actions => {
        return actions.map(a => {
          const data = a.payload.doc.data() as any;
          data.id = a.payload.doc.id;
          if(a.payload.doc.data()['doctors_default']) {
            data.default = (a.payload.doc.data()['doctors_default'].includes(doc.id));
          }
          return data;
        });
      })
      .subscribe((supplies) => {
        console.log('Supplies: ', supplies)
        this.suppliesList = supplies;
        // this.supplistOrderList = JSON.parse(JSON.stringify(supplies));
      });

      this.database.getClinic(this.clinic_id).valueChanges()
      .take(1).toPromise()
      .then(clinic => {
        this.clinic = clinic;
      });
    });

    console.log('Clinic: ', this.clinic);

    this.first_name = new FormControl("", Validators.required);
    this.last_name = new FormControl("", Validators.required);
    this.license_number = new FormControl("", Validators.required);

    this.doctor = formBuilder.group({
      first_name: this.first_name,
      last_name: this.last_name,
      license_number: this.license_number,
    });

    if (this.navParams.get('doctordata')) {
      const doc: any = this.navParams.get('doctordata');
      console.log(doc.id);
      this.doctor.patchValue(doc);
      this.doctor['signature'] = doc.signature;
      this.doctor_id = doc.id;
      this.isExisting = true;
      this.operation_type = "Edit " + doc.first_name + " " + doc.last_name;
    }
  }

  ionViewDidLoad() {
    if(this.isExisting)  {
      this.signaturePad.fromDataURL(this.doctor['signature'], {width: 500, height: 150});
    }
  }

  addDoctor() {
    if (this.signaturePad.isEmpty()) {
      let alert = this.alertCtrl.create({
        title: "Doctor Signature",
        subTitle: "You must add a signature of the doctor",
        buttons: ["OK"]
      });
      alert.present();
      alert.onDidDismiss(() => {
        this.addupdatedisabled = false;
      })
    } else {
      let loading = this.loadingCtrl.create({});
      loading.present();
      this.signature = this.signaturePad.toDataURL();
      let doc: {} = this.doctor.value;
      doc['signature'] = this.signature;
      console.log('Clinic: ', this.clinic_name);
      this.database.addDoctor(this.clinic_id, doc).then((doctor) => {
        // this.clinic.lo
        this.clinic.locations.push({name: this.clinic_name});
        const promises = new Array<Promise<any>>();
        for (const location of this.clinic.locations) {
          const newNursingHome: any = {
            clinic_id: this.clinic_id,
            clinic_name: this.clinic_name,
            doctor_id: doctor.id,
            doctor_name: doc['first_name'] + " " + doc['last_name'],
            location: location.name,
            createdAt: this.database.timestamp,
            in_kroll: false
          };
          promises.push(this.database.createNursingHome(newNursingHome));
        }
        return Promise.all(promises);
      }).then(() => {
        console.log('Successfully updated the doctor');
        loading.dismiss().then(()=>{
          this.dismiss();
        });
      }).catch((error) => {
        console.log(error);
        loading.dismiss()
      });
      console.log("Doctor: ", this.doctor);
    }
  }

  updateDoctor() {
    if (this.signaturePad.isEmpty()) {
      let alert = this.alertCtrl.create({
        title: "Doctor Signature",
        subTitle: "You must add a signature of the doctor",
        buttons: ["OK"]
      });
      alert.present();
      alert.onDidDismiss(() => {
        this.addupdatedisabled = false;
      })
    } else {
      let loading = this.loadingCtrl.create({});
      loading.present();
      this.signature = this.signaturePad.toDataURL();
      let doc: any = this.doctor.value;
      doc['signature'] = this.signature;
      this.database.updateDoctor(this.clinic_id, this.doctor_id, doc).then(() => {
        console.log('Successfully updated the doctor');
        loading.dismiss().then(()=>{
          this.dismiss();
        });
      })
      .catch((error) => {
        console.log('Error updating the doctor');
        loading.dismiss();
      });
      console.log("Doctor: ", this.doctor);
    }
  }

  clearPad() {
    this.signaturePad.clear();
  }

  saveSignature() {
    this.signature = this.signaturePad.toDataURL();
  }

  drawComplete() {
    this.isDrawing = false;
  }

  drawStart() {
    this.isDrawing = true;
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }


  checkToggled(doctors) {
    if(doctors) {
      return (doctors.includes(this.doctor_id));
    } else {
      return false;
    }
  }

  updateSuppliesDefault(ev, supply) {
    if (ev.value) {
      if(supply.doctors_default) {
        supply.doctors_default.push(this.doctor_id);
      }
      else {
        supply['doctors_default'] = [];
        supply.doctors_default.push(this.doctor_id);
      }
    } else {
      if(supply.doctors_default)  {
        const index: number = supply.doctors_default.indexOf(this.doctor_id, 0);
        if (index > -1) {
          supply.doctors_default.splice(index, 1);
       }
      }
    }
    this.database.updateSupply(supply)
    .then(()=>{})
    .catch((err) => {});
  }
}



// WEBPACK FOOTER //
// ./src/pages/clinic-doctors-add/clinic-doctors-add.ts